/** @deprecated use enum instead */
export const answer = {
    YES: 'yes',
    NO: 'no'
};
export enum YesNo {
    yes = 'yes',
    no = 'no',
}
